import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_delivery_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_goods_received_note_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_goods_received_note_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_purchase_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_purchase_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    matching_status: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    int_purchase_order_doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass implements bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_delivery_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_goods_received_note_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_goods_received_note_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_purchase_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_purchase_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    matching_status: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    int_purchase_order_doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
